module.exports = __webpack_public_path__ + "media/images/weather/205_night-f2e9d6560823e962bf2ddfd3a0b84bf4.png";